import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPreviousTrainingPrograms, chooseTrainingProgram, renameTrainingProgram, clearMessage } from '../../../redux/slices/customer/trainingSlice';
import Layout from '../Layout';
import Back from '../../../components/common/Back';

const PreviousTrainingPrograms = () => {
  const dispatch = useDispatch();
  const { programs, error } = useSelector((state) => state.customer_training);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProgram, setSelectedProgram] = useState(null);
  const [programName, setProgramName] = useState('');

  useEffect(() => {
    dispatch(fetchPreviousTrainingPrograms());
  }, [dispatch]);

  useEffect(() => {
    dispatch(clearMessage());
  }, []); 

  const handleRenameClick = (plan) => {
    setSelectedProgram(plan);
    setProgramName(plan.program_name);
    setIsModalOpen(true);
  };

  const handleProgramNameChange = (e) => {
    setProgramName(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Dispatch the action to rename the program
    dispatch(renameTrainingProgram({ id: selectedProgram.id, title: programName }));
    
    // Close the modal after renaming and refresh the list
    setIsModalOpen(false);
    dispatch(fetchPreviousTrainingPrograms());
  };

 

  const handleChooseClick = async (programId) => {
  const confirmed = window.confirm("Are you sure you want to choose this program?");
  
  if (confirmed) {
    try {
      // Dispatch the chooseTrainingProgram action
      await dispatch(chooseTrainingProgram(programId)).unwrap();

      // Refresh the list of training programs after choosing one
      dispatch(fetchPreviousTrainingPrograms());
    } catch (error) {
      console.error("Error choosing the program: ", error);
    }
  }
};


  return (
    <Layout>
      <main className="main" style={{ overflow: 'unset' }}>
        <div className="card-entries mt-3">
          <header className="main-head flex justify-between align-center">
            <h1 className="greet-user-text">Training History</h1>
            <div className="ms-auto">
              <Back />
            </div>
          </header>

          <div className="page-subheading pb-3">
            <h4>Select from the programs you have previously used:</h4>
          </div>

          <div className="main-content flex justify-between flex-col-rev-mob">
            <div className="phases-container">
              <div className="card responsive-table-container p-0">
                <table className="admin-table current-ingredients-table">
                  <thead>
                    <tr>
                      <th>Program Name</th>
                      <th>Previously Used</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {error ? (
                      <tr>
                        <td colSpan="3">Error: {error}</td>
                      </tr>
                    ) : (
                      programs.map((plan) => (
                        <tr key={plan.id}>
                          <td>{plan.program_name}</td>
                          <td>{new Date(plan.creation_date).toLocaleDateString()}</td>
                          <td>
                            <button
                              className={`btn-choose ${plan.is_active ? 'active' : ''}`}
                              style={{
                                backgroundColor: plan.is_active ? 'green' : '',
                                color: plan.is_active ? 'white' : ''
                              }}
                              onClick={() => handleChooseClick(plan.id)}
                            >
                              {plan.is_active ? 'Active' : 'Choose'}
                            </button>

                            <button className="btn-choose ms-2" onClick={() => handleRenameClick(plan)}>Rename</button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Modal for renaming the program */}
      {isModalOpen && (
        <div className="modal fade show d-block" id="steps-check-in-modal" tabIndex="-1" aria-labelledby="stepsCheckInLabel" aria-hidden="true" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header justify-content-center">
                <h5 className="modal-title" id="stepsCheckInLabel">Edit Program Name</h5>
                <button type="button" className="btn-close" aria-label="Close" onClick={() => setIsModalOpen(false)}></button>
              </div>
              <div className="modal-body px-md-5 pb-md-4">
                <form onSubmit={handleSubmit}>
                  <div className="row g-3 gx-md-5 gy-md-4">
                    <div className="col-md-12">
                      <input
                        type="text"
                        required
                        className="form-control form-control-lg"
                        value={programName}
                        onChange={handleProgramNameChange}
                      />
                    </div>
                    <div className="col-md-12">
                      <button type="submit" className="btn btn-create w-100">Update</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default PreviousTrainingPrograms;